import { useState, useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'

export function UserProfile() {
  const { user } = useAuth()
  const [isMobile, setIsMobile] = useState(false)

  const getRoleLabel = (role: string) => {
    switch (role) {
      case 'admin':
        return 'Administratör'
      case 'lla':
        return 'LLA'
      case 'lobby':
        return 'Lobby'
      case 'user':
        return 'Användare'
      default:
        return 'Okänd roll'
    }
  }

  const getRoleStyle = (role: string) => {
    switch (role) {
      case 'admin':
        return { backgroundColor: '#dc2626', color: 'white' }
      case 'lla':
        return { backgroundColor: '#7c3aed', color: 'white' }
      case 'lobby':
        return { backgroundColor: '#f59e0b', color: 'white' }
      default:
        return { backgroundColor: '#059669', color: 'white' }
    }
  }

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }
    
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  if (!user) return null

  return (
    <div style={{
      backgroundColor: 'white',
      padding: isMobile ? '20px' : '24px',
      borderRadius: '12px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e2e8f0',
      marginBottom: '30px'
    }}>
      <h3 style={{ margin: '0 0 16px 0', color: '#1a202c', fontSize: isMobile ? '16px' : '18px' }}>Din Profil</h3>
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(250px, 1fr))', 
        gap: isMobile ? '12px' : '16px' 
      }}>
        <div>
          <p style={{ margin: '0 0 4px 0', fontSize: '14px', color: '#64748b', fontWeight: '500' }}>Namn</p>
          <p style={{ margin: '0 0 12px 0', color: '#1a202c' }}>{user?.displayName || user?.name || 'Ej angivet'}</p>
        </div>
        <div>
          <p style={{ margin: '0 0 4px 0', fontSize: '14px', color: '#64748b', fontWeight: '500' }}>E-post</p>
          <p style={{ margin: '0 0 12px 0', color: '#1a202c' }}>{user?.email || 'Ej angivet'}</p>
        </div>

        <div>
          <p style={{ margin: '0 0 4px 0', fontSize: '14px', color: '#64748b', fontWeight: '500' }}>Mobiltelefon</p>
          <p style={{ margin: '0 0 12px 0', color: '#1a202c' }}>{user?.mobilePhone || 'Ej angivet'}</p>
        </div>
        <div>
          <p style={{ margin: '0 0 4px 0', fontSize: '14px', color: '#64748b', fontWeight: '500' }}>Roll</p>
          <p style={{ margin: '0 0 12px 0', color: '#1a202c' }}>
            <span style={{
              ...getRoleStyle(user?.role || ''),
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '12px',
              fontWeight: '500'
            }}>
              {getRoleLabel(user?.role || '')}
            </span>
          </p>
        </div>
        <div>
          <p style={{ margin: '0 0 4px 0', fontSize: '14px', color: '#64748b', fontWeight: '500' }}>Språk</p>
          <p style={{ margin: '0 0 12px 0', color: '#1a202c' }}>{user?.preferredLanguage || 'Ej angivet'}</p>
        </div>
      </div>
    </div>
  )
}